import { SpacesRemainingTag } from 'Modules/FerrySchedule/Components/SpacesRemaining/SpacesRemainingTag';
import React from 'react';

import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import { LegOptionContext } from './Contexts/LegOptionContext';

export default function LegOptionCargoCapacity() {
	const context = React.useContext(LegOptionContext);

	if (!context) {
		console.error('LegOptionContext is missing in LegOptionCargoCapacity');
		return null;
	}

	const { wizardData } = context;

	if (wizardData.tabSelected !== 'vehicle') {
		return null;
	}

	const { cargoSpaces, cargoSpacesExact, cargoSpacesBasedOnType } = context;
	return (
		<LegOptionCargoCapacityInner
			space={cargoSpaces}
			exactSpace={cargoSpacesExact}
			spaceBasedOnType={cargoSpacesBasedOnType}
			closed={context.vehicleBookingsClosed}
			showName={context.showCapacityNames}
			explainClosed={context.explainClosedCapacity}
			explainState={context.explainCapacityState}
		/>
	);
}

interface LegOptionCargoCapacityInnerProps {
	space?: number;
	/** The unfloored figure, shown to a manager when the sailing is over capacity. */
	exactSpace?: number;
	spaceBasedOnType?: 'weight' | 'length';
	closed: boolean;
	/** Names the capacity beside its icon. See `showCapacityNames` on the leg-option context. */
	showName?: boolean;
	/** Explains `(closed)`. See `explainClosedCapacity` on the leg-option context. */
	explainClosed?: boolean;
	/** Tooltip describes the state, not the name. See `explainCapacityState` on the context. */
	explainState?: boolean;
}

export function LegOptionCargoCapacityInner({
	space,
	exactSpace,
	spaceBasedOnType,
	closed,
	showName = false,
	explainClosed = false,
	explainState = false,
}: LegOptionCargoCapacityInnerProps) {
	return (
		<SpacesRemainingTag
			space={space ?? 0}
			exactSpace={exactSpace}
			capacityName="Vehicles"
			icon={<Icon name="directions_car" useMaterialIcons />}
			showName={showName}
			explainClosed={explainClosed}
			explainState={explainState}
			closed={closed}
			tooltipText={showName ? undefined : 'Vehicles'}
		/>
	);
}
